import { WebParameterContext, WebResponesContext } from '../../model/common';
export class Servicessection{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    webcontext.RequestBody={};
    webcontext.RequestBody.Type=2;//转段 
    return webcontext;
  }

}